var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('EllipsisTip',[_vm._v(_vm._s(_vm.item.keyword))])],1),_c('td',[_c('div',{staticClass:"c-text--center"},[_c('p',[_vm._v(_vm._s(_vm._f("dateText")(_vm.item.createdAt,'YYYY.MM.DD')))])])]),_c('td',[_c('Button',{attrs:{"to":{
        name: 'contentPlansSurvey',
        query: {
          createdAt: _vm.convertDateJst,
          keyword: _vm.item.keyword
        }
      },"size":"w180","fsize":"f14","icon":"arrow_r","variant":"main"}},[_vm._v("\n      結果を見る\n    ")])],1),_c('td',{staticClass:"c-text--center"},[_c('Button',{attrs:{"variant":"delete","disabled":_vm.isDeleting},on:{"click":_vm.deleteItem}},[_vm._v("\n      削除\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }